// extracted by mini-css-extract-plugin
export default {"black":"Button_black__G8rVG","blue":"Button_blue__rScni","scroll_top_btn":"Button_scroll_top_btn__NCOTP"};